/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Property_PriorityInputs */



/**
* | output |
* | --- |
* | "Priority" |
*
* @param {Explorer_Info_Property_PriorityInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_property_priority = /** @type {((inputs?: Explorer_Info_Property_PriorityInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Property_PriorityInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Priority")
	if (locale === "de") return /** @type {LocalizedString} */ ("Priority")
	if (locale === "it") return /** @type {LocalizedString} */ ("Priority")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Priority")
	if (locale === "es") return /** @type {LocalizedString} */ ("Priority")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Priority")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Priority")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Priority")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Priority")
	return /** @type {LocalizedString} */ ("Priority")
});